<template>
	<v-container>
		<div class="login-background"></div>
		<v-main>
			<v-container>
				<v-row class="mb-5">
					<v-spacer></v-spacer>
					<img :src="publicPath + 'logo.png'" class="logo"/>
					<v-spacer></v-spacer>
				</v-row>
				<v-row class="mb-5">
					<v-spacer></v-spacer>
					<v-col md="4" sm="8" cols="12">
						<v-card class="transparent-login-form" outlined tile>
							<v-card-text>
								<InputField
									:error="loginValidation.username" :label="$t('fields.username')"
									@keyup.native.enter="loginClick" v-model="loginData.username"></InputField>
								<InputField
									:error="loginValidation.password" :label="$t('fields.password')"
									:type="'password'" @keyup.native.enter="loginClick"
									v-model="loginData.password"></InputField>
								<CheckBox
									:label="$t('fields.rememberMe')"
									v-model="loginData.remember_me"></CheckBox>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn depressed color="primary" @click="loginClick">
									<v-icon class="mr-2">fa-sign-in-alt</v-icon>
									{{ $t('buttons.login') }}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
					<v-spacer></v-spacer>
				</v-row>
				<v-row>
					<v-col cols="12">
						<div class="mt-3 body-1 text-center" v-html="$getSettings('FOOTER_HTML')"></div>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";

export default {
	name: "Login",
	components: {CheckBox, InputField},
	data: function () {
		return {
			publicPath: process.env.BASE_URL,
			loginData: {
				username: '',
				password: '',
				remember_me: false
			},
			loginValidation: {
				username: '',
				password: ''
			}
		}
	},
	methods: {
		loginClick() {
			let success = true;

			if (this.loginData.username == '') {
				success = false;
				this.loginValidation.username = this.$t('alerts.usernameMissing');
			} else {
				this.loginValidation.username = '';
			}

			if (this.loginData.password == '') {
				success = false;
				this.loginValidation.password = this.$t('alerts.passwordMissing');
			} else {
				this.loginValidation.password = '';
			}

			if (success) {
				let vm = this;
				this.$APICall('post', 'login', this.loginData, (data, success) => {
					if (success) {
						vm.$myStore.commit('setUser', data.user);
						vm.$myStore.commit('setLoggedIn', true);
						vm.$router.push('dashboard');
						if (data.version !== this.$getCookie('m42_version')) {
							this.$setCookie('m42_version', data.version);
							window.location.reload(true);
						}
					} else {
						vm.$alert(vm.$t('alerts.loginFail'));
					}
				});
			}
		}
	},
	mounted() {
		this.$myStore.commit('setUser', null);
		this.$myStore.commit('setLoggedIn', false);
	}
}
</script>

<style>
>>> .logo {
	width: 400px;
}

.login-background {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100vw;
	height: 100vh;

	background-color: #ccdcff;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(240)'%3E%3Cstop offset='0' stop-color='%23ccdcff'/%3E%3Cstop offset='1' stop-color='%23a3cdff'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
	background-attachment: fixed;
	background-size: cover;
}

.transparent-login-form {
	background-color: rgba(255,255,255,0.3) !important;
	border-color: transparent!important;
}
</style>
